<template>
<v-container>
    <v-text-field solo label="Søg" append-icon="search" v-model="searchString"></v-text-field>
    <v-data-table v-if="$vuetify.breakpoint.smAndUp" :headers="headers" :items="bookings" class="elevation-1" :pagination.sync="pagination" rows-per-page-text="Rækker per side">
        <template slot="items" slot-scope="props">
            <tr :style="[{'background': `${activeDate(props.item.date) }`},{'color': `${activeDateText(props.item.date) }`}]">
                <td>{{ props.item.resName }}</td>
                <td class="text-xs-left">{{props.item.horseName}}</td>
                <td class="text-xs-left">{{props.item.date}} </td>
                <td class="text-xs-left">{{props.item.time}} </td>
                <td class="text-xs-left">{{props.item.userName}} </td>
                <td class="text-xs-center" v-if="adminOn">
                    <v-btn flat icon @click="deleteBooking(props.item.id)">
                        <v-icon>delete</v-icon>
                    </v-btn>
                </td>
            </tr>
        </template>
        <template slot="no-data">
            <v-alert :value="true" color="grey">
                Der er ikke nogen reservationer at vise
            </v-alert>
        </template>
    </v-data-table>

    <v-data-iterator v-if="$vuetify.breakpoint.xsOnly" :items="bookings" :pagination.sync="pagination" rows-per-page-text="Rækker per side" row wrap>
        <v-flex slot="item" slot-scope="props" xs12>

            <v-card flat :style="[{'background': `${activeDate(props.item.date) }`},{'color': `${activeDateText(props.item.date) }`}]">
                <v-layout row wrap class="pa-3">
                    <v-flex xs6 sm2 md2>
                        <div class="caption grey--text">Fold</div>
                        <div>{{props.item.resName}}</div>
                    </v-flex>
                    <v-flex xs6 sm3 md3>
                        <div class="caption grey--text">Hest</div>
                        <div>{{props.item.horseName}}</div>
                    </v-flex>
                    <v-flex xs6 sm3 md3>
                        <div class="caption grey--text">Tid</div>
                        <div>{{props.item.time}}</div>
                    </v-flex>
                    <v-flex xs6 sm3 md3>
                        <div class="caption grey--text">Bruger</div>
                        <div>{{props.item.userName}}</div>
                    </v-flex>
                    <v-flex xs6 sm3 md3 v-if="adminOn">
                        <div class="caption grey--text">Dato</div>
                        <div>{{props.item.date}}</div>
                    </v-flex>
                    <v-flex xs6 sm3 md3 v-if="adminOn">
                        <div>
                            <v-btn flat icon @click="deleteBooking(props.item.id)">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </div>
                    </v-flex>

                </v-layout>
                <v-divider></v-divider>
            </v-card>

        </v-flex>
        <template slot="no-data">
            <v-alert :value="true" color="grey">
                Der er ikke nogen reservationer at vise
            </v-alert>
        </template>
    </v-data-iterator>

    <v-layout row wrap>
        <v-flex xs12 md6 v-if="adminOn">
            <v-switch name="old" label="Vis kun aktive reservationer" v-model="showNew"></v-switch>
        </v-flex>
        <v-flex xs12 md6 v-if="!adminOn">
            <v-switch name="all" label="Vis reservationer på alle folde" v-model="showAll"></v-switch>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
export default {
    data() {
        return {
            searchString: '',
            showNew: false,
            showToday: true,
            showAll: false,
            pagination: {
                rowsPerPage: 5
            },

        }
    },
    props: {
        adminOn: Boolean,
        userid: String
    },
    computed: {
        headers() {
            var header = [{
                    text: 'Fold',
                    align: 'left',
                    value: 'resName'
                },
                {
                    text: 'Hest',
                    align: 'left',
                    value: 'horseName'
                },
                {
                    text: 'Dato',
                    align: 'left',
                    value: 'date'
                },
                {
                    text: 'Tid',
                    align: 'left',
                    value: 'time'
                },
                {
                    text: 'Bruger',
                    align: 'left',
                    value: 'userName'
                },

            ]
            if (this.adminOn) {
                header.push({
                    text: 'Slet',
                    align: 'center',
                    value: 'delete'
                })
            }
            return header

        },
        users() {
            return this.$store.getters.users
        },
        horses() {
            return this.$store.getters.horses
        },
        resources() {
            return this.$store.getters.resources
        },
        bookings() {
            var result = null;

            result = this.$store.getters.bookings

            //filter out for current user 
            if (this.userid !== '' && typeof this.userid !== 'undefined') {
                //console.log('###' + this.userid)

                result = result.filter(booking => {
                    //console.log('### booking.date ' + booking.date)
                    //console.log('### this.$store.getters.dateSelected' + this.$store.getters.dateSelected)
                    return booking.userid === this.userid
                })
            }

            //Filter out inactive users
            if (this.showNew) {
                //console.log('###')

                result = result.filter(booking => {
                    //console.log('### booking.date ' + booking.date)
                    //console.log('### this.$store.getters.dateSelected' + this.$store.getters.dateSelected)
                    return booking.date >= this.$store.getters.dateSelected
                })
            }
            if (this.showToday) {
                //console.log('###')

                result = result.filter(booking => {
                    //console.log('### booking.date ' + booking.date)
                    //console.log('### this.$store.getters.dateSelected' + this.$store.getters.dateSelected)
                    return booking.date === this.$store.getters.dateSelected
                })
            }

            //Filter based on redid
            if (!this.showAll) {
                //console.log('¤¤¤')
                result = result.filter(booking => {
                    // console.log('¤¤¤ booking.resid ' + booking.resid)
                    // console.log('¤¤¤ this.$store.getters.resid' + this.$store.getters.resid)                    
                    return booking.resid === this.$store.getters.resid
                })
            }

            //Filter based on search
            if (this.searchString !== '') {
                result = result.filter(booking => {
                    return booking.userName.toLowerCase().includes(this.searchString.toLowerCase()) ||
                        booking.horseName.toLowerCase().includes(this.searchString.toLowerCase()) ||
                        booking.date.toLowerCase().includes(this.searchString.toLowerCase()) ||
                        booking.resName.toLowerCase().includes(this.searchString.toLowerCase())
                })
            }

            return result
        }

    },
    created: function () {
        if (this.adminOn) {
            this.showAll = true
            this.showNew = true
            this.showToday = false

        }

    },
    methods: {
        activeDate: function (bookingDate) {
            if (bookingDate < this.$store.getters.dateCurrent) {
                return '#e0e0e0'
            } else {
                return ''
            }
        },
        activeDateText: function (bookingDate) {
            if (bookingDate < this.$store.getters.dateCurrent) {
                return '#9e9e9e'
            } else {
                return ''
            }
        },
        deleteBooking(bookingid) {
            //console.log('delete:' + bookingid)
            const db = this.$firebase.firestore()
            db.collection('bookings').doc(bookingid).delete().then(() => {
                    this.$store.dispatch('loadBookings', {
                        vm: this
                    })

                })
                .catch(err => {
                    console.log(err.message)
                });
        },

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>
